"use client"

import PropTypes from "prop-types"
import ToolContainer from "./container"
import TrainingSettings from "./multi/trainingsettings"
import Training from "./multi/training"
import { useLanguage } from "../../../../contexts/LanguageContext"
import { Icons } from "../../../../components/Icons"

const Multi = ({ onExit }) => {
  const { t } = useLanguage()

  return (
    <div>
      <header className="toolswitcher">
        <h1>{t("multiplicationDivision")}</h1>
        <button onClick={() => onExit("types")} className="btn btn-secondary flex items-center space-x-2">
          <Icons.ArrowLeft className="w-4 h-4" />{t('trainings.back')}
        </button>
      </header>
      <ToolContainer
        settingsContainer={(action) => <TrainingSettings onStart={action} />}
        processContainer={(action, onNext, player) => <Training onFinish={action} onNext={onNext} player={player} />}
      />
    </div>
  )
}

Multi.propTypes = {
  onExit: PropTypes.func.isRequired,
}

export default Multi
